export default __webpack_public_path__ + "static/bc-distort-shader-14553c8832bed7bc5cd7b6313064e309.mp4";